
// Set the dayjs date to the given time ( received in HH:mm format )
export const setTimeOfDate = (date, time) => {
  const [hours, minutes] = time.split(":");
  return date.set("hour", parseInt(hours)).set("minute", parseInt(minutes));
};

export const clampRangeToMinDate = (from, to, minDate) => {
  if (minDate && to && to.isBefore(minDate, "d")) return null;
  const clampedFrom = minDate && from && from.isBefore(minDate, "d") ? minDate : from;
  return [clampedFrom, to];
};
